// src/components/LogoutWarningModal.jsx
import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";
import { useAutoLogout } from "app/contexts/AutoLogoutProvider";

const LogoutWarningModal = () => {
  const { showModal, setShowModal, minutes, seconds, resetTimer } =
    useAutoLogout();

  const handleStay = () => {
    resetTimer();
    setShowModal(false);
  };

  return (
    <Dialog open={showModal} onClose={handleStay} maxWidth="xs" fullWidth>
      <DialogTitle>Are you still there?</DialogTitle>
      <DialogContent>
        <Typography>
          You will be logged out in{" "}
          <strong>
            {minutes}:{String(seconds).padStart(2, "0")}
          </strong>{" "}
          due to inactivity.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={handleStay} color="primary">
          Stay Logged In
        </Button>
        <Button onClick={() => setShowModal(false)} color="inherit">
          Ignore
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default LogoutWarningModal;
